export interface BrandConfig {
  domain: string;
  siteUrl: string;
  siteName: string;
  tagline: string;
  description: string;
  ogImage: string;
  copyright: string;
  foundingYear: string;
}

const BRANDS: Record<string, BrandConfig> = {
  'vacant.day': {
    domain: 'vacant.day',
    siteUrl: 'https://vacant.day',
    siteName: 'vacant.day',
    tagline: 'Every holiday, on display.',
    description: 'Every public holiday, festival, and observance across 14 countries — on display, your way.',
    ogImage: 'https://storage.googleapis.com/almanak-event-heroes/landing/og-image.png',
    copyright: 'vacant.day',
    foundingYear: '2025',
  },
};

/** Calendar layout — which presentation to render (ViewSwitcher) */
export type CalendarLayout = 'hybrid' | 'grid' | 'timeline' | 'poster' | 'list';
export const LAYOUT_OPTIONS: Array<{ id: CalendarLayout; label: string; icon: string }> = [
  { id: 'hybrid', label: 'Hybrid', icon: '⊞' },
  { id: 'grid', label: 'Grid', icon: '▦' },
  { id: 'timeline', label: 'Timeline', icon: '☰' },
  { id: 'poster', label: 'Poster', icon: '▧' },
  { id: 'list', label: 'List', icon: '≡' },
];

const key = process.env.NEXT_PUBLIC_BRAND || 'vacant.day';
export const brand: BrandConfig = BRANDS[key] || BRANDS['vacant.day'];
export const SITE_URL = brand.siteUrl;
export const SITE_NAME = brand.siteName;
